export default __webpack_public_path__ + "static/media/crypto yellow.8c4dce8f.svg";